<template>
  <slot
    v-bind="{
      isSaveWarningShown,
      isShipmentWarningShown,
      entriesListTree,
      b2bUnitShippingDays,
      totals,
      tabSelected,
      containers,
      loading,
      freightTotals,
      fetchTotalsWithFreight,
      isConsumerFriendlyMode,
      goToNextCheckoutStep,
      tabLabelMap,
      isOrderDetailsLoading,
      shipmentsInfo,
      warehousesMap,
      updateShipmentProperty,
      updateSelectedTab,
    }"
  ></slot>
</template>
<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import {ProductType} from '@/constants/product';
import {scrollToElement} from '@/utils/scroll-to';
import {useVuelidate} from '@vuelidate/core';
import {focusElement} from '@/utils/accessibility/a11y-utils';

export default {
  name: 'CheckoutContainerShipments',

  props: {
    isDropShipCustomer: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {v$: useVuelidate()};
  },
  data() {
    return {
      dialogVisible: false,
      loading: true,
      selectedTabName: '',
      isSaveWarningShown: false,
      orderData: '',
      orderNumber: '',
      isOrderDetailsLoading: true,
    };
  },

  computed: {
    tabSelected: {
      get() {
        return this.selectedTabName ? this.selectedTabName : this.entries[0]?.groupingType;
      },
      set(name) {
        this.selectedTabName = name;
      },
    },

    tabLabelMap() {
      return {
        [ProductType.Bike]: this.$t('text.bikes'),
        [ProductType.Aftermarket]: this.$t('text.accessories'),
        [ProductType.CustomWaterBottles]: this.$t('checkout.custom'),
        [ProductType.ProjectOne]: this.$t('checkout.projectOne'),
      };
    },

    // Show shipment warning if there is more than 1 warehouse
    isShipmentWarningShown() {
      return this.entriesListTree.some(([type, entries]) => type === this.tabSelected && entries.length > 1);
    },

    ...mapGetters('advancedOrdering', ['aoToggleCompletedWatcher']),
    ...mapGetters('user', ['b2bUnitShippingDays']),
    ...mapGetters('shipments', ['entriesListTree', 'warehousesMap']),
    ...mapState('backend', ['encodedContextPath', 'isConsumerFriendlyMode']),
    ...mapState('miniCart', ['containers']),
    ...mapState('shipments', ['entries', 'warehouses', 'shipmentsInfo', 'totals', 'freightTotals']),
  },

  watch: {
    aoToggleCompletedWatcher() {
      this.loadCart();
    },
  },

  async created() {
    this.loadShipmentsInfo();
    this.loadCart();

    if (this.isDropShipCustomer) {
      this.fetchMiniCart();
    }

    await this.fetchTotals();

    this.loading = false;
  },

  methods: {
    changeGridTab(tab) {
      this.tabSelected = tab;
      scrollToElement('#order-tabs', 150);
    },

    goToNextCheckoutStep() {
      this.v$.$validate().then((isValid) => {
        if (!isValid) {
          const firstErrorFieldNameType = document
            .querySelector('.has-error .form-control')
            ?.getAttribute('name')
            ?.split('-')?.[0];
          this.changeGridTab(firstErrorFieldNameType);
          this.$nextTick(() => {
            focusElement(document.querySelector('.has-error'));
          });
        } else {
          this.handleShipmentsBeforeUnload();
        }
      });
    },

    // Handles the data update to the BE when the user navigates away from Shipments page
    async handleShipmentsBeforeUnload() {
      const result = await this.updateShipmentsDetails({
        shipments: this.shipmentsInfo.shipments,
      });
      if (result) {
        window.location = `${this.encodedContextPath}/checkout/multi/shipment/next/`;
      } else {
        this.isSaveWarningShown = true;
      }
    },

    async loadCart() {
      await this.fetchCart();
    },

    async loadShipmentsInfo() {
      await this.fetchShipmentsInfo();
      for (const data in this.shipmentsInfo.shipments) {
        this.shipmentsInfo.shipments[data]['type'] = data;
      }
      this.isOrderDetailsLoading = false;
    },

    updateSelectedTab(tab) {
      this.tabSelected = tab;
    },

    ...mapMutations('shipments', ['updateShipmentProperty']),
    ...mapActions('miniCart', ['fetchMiniCart']),
    ...mapActions('shipments', [
      'fetchCart',
      'fetchShipmentsInfo',
      'fetchTotals',
      'fetchTotalsWithFreight',
      'updateShipmentsDetails',
    ]),
  },
};
</script>
